// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"530":"e153a415","676":"64f842a8","788":"777408e2","881":"ab1631d8","962":"6fb15a99","970":"fbdb5f2e","977":"87eb25dd"}[chunkId] + ".chunk.css";
};